import { render, staticRenderFns } from "./CompanyProducts.vue?vue&type=template&id=2956e6bb&scoped=true"
import script from "./CompanyProducts.vue?vue&type=script&lang=js"
export * from "./CompanyProducts.vue?vue&type=script&lang=js"
import style0 from "./CompanyProducts.vue?vue&type=style&index=0&id=2956e6bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956e6bb",
  null
  
)

export default component.exports